import { BuildingTypes } from "./buildingTypes";
import {
  DeviceType,
  EnergyGroups,
  EnergyStatus,
  WifiQuality,
} from "./onboardingTypes";

/** Availabe actions for a scene */
export enum SceneAction {
  AC_ON = 1,
  AC_OFF = 2,
}

export enum MaintenanceState {
  NEW = "Novo",
  GOOD = "Bom",
  BAD = "Ruim",
}

export enum LightActivationType {
  CIRCUIT_BREAKER = "Disjuntor",
  PRESENCE_SENSOR = "Sensor de presença",
  INDIVIDUAL_SWITCH = "Interruptor individual",
  AREA_SWITCH = "Interruptor de área",
}

export enum LightCeilingType {
  PLASTER = "Gesso",
  PVC = "PVC",
  CONCRETE = "Laje",
  DROP_CEILING = "Forro pacote",
}

export type Environment = {
  id: string;
  isMember: boolean;
  name: string;
  offlineDevices: number;
  onlineDevices: number;
};

export type SceneDetail = {
  id: string;
  action: string;
  isActive: boolean;
  name: string;
  spaces: Array<Environment>;
  temperature: number;
  triggerTime: string;
  weekMap: string;
};

export type AutomationSpace = {
  id: string;
  schoolName: string;
  brand: string;
  contractCode: string;
  hasDiscarbonizationProfile: boolean;
  isProsumer: boolean;
  hasSmartMeter: boolean;
  hasInfrared: boolean;
  properties: Array<AutomationSpaceProperties>;
};

export type AutomationSpaceProperties = {
  id: string;
  userId: string;
  propertyName: string;
  propertyType: BuildingTypes;
  city: string;
  monthlyEnergyCost: string;
  airConditionedRoomsCount: string;
  wifiQuality: WifiQuality;
  electricalPanelCapacity: string;
  voltageLevel: EnergyGroups;
  hasGreenEnergyContract: EnergyStatus;
  discountPercentage: number;
  airSplit: number;
  airWindow: number;
  airCassette: number;
  rootSpaceId: string;
  invoiceEnergyPath: string;
  buildingImagePath: string;
};

export type AcModel = Record<"name" | "id", string>;

export type AcProperties = {
  id?: string;
  airName: string;
  type?: DeviceType;
  model?: AcModel;
  procelBadge?: string;
  inmetro?: string;
  power?: string;
  amount?: string;
  efficiency?: string;
  age?: string;
  maintenanceState?: MaintenanceState;
  workingHours?: string;
  obs?: string;
  pictures?: HTMLInputElement["files"];
};

export type ElectricalPanelTypes = {
  id: string;
  name: string;
  code: string;
  description: string;
};

export type LightingTypes = {
  id: string;
  name: string;
  description: string;
};
